import { cva, type VariantProps } from "cva";

import styles from "./index.module.css";

export const variants = cva({
  base: styles.base,
  variants: {
    variant: {
      solid: styles.solid,
      filled: styles.filled,
      outlined: styles.outlined,
    },
    width: {
      full: styles.full,
      fit: styles.fit,
    },
    color: {
      key: styles.key,
      caution: styles.caution,
      invariable: styles.invariable,
    },
    loading: {
      true: styles.loading,
      false: "",
    },
  },
  defaultVariants: {
    variant: "solid",
    width: "full",
    loading: false,
  },
});

export type ButtonVariantProps = VariantProps<typeof variants>;
